/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-10 20:58:27
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 12:30:07
 * @FilePath: /wemeet-web-activity/src/components/Coupon/useReceiveCoupon.ts
 * @Description: 领券hook
 */
import { useState, useCallback } from 'react';
import { message } from '@tencent/tea-component';
import ActivitiesCouponReceive from "../quickServices/ActivitiesCouponReceive";
import buyerCoupon from "./modal/buyer-coupon";
const useReceiveCoupon = (http, coupon) => {
  const [isLoading, setIsLoading] = useState(false);
  const receiveCoupon = useCallback(async () => {
    // @ts-ignore
    if (!isLoading && coupon?.user_coupon_state === 0) {
      setIsLoading(true);
      // 未领取过且状态正常的优惠券的话，就进行优惠券领取
      const res = await ActivitiesCouponReceive({
        coupon_id: coupon.coupon_id || ''
      }, http).then(res => {
        setIsLoading(false);
        if (!res) {
          return false;
        }
        if (res.code !== 0) {
          message.error({
            content: res.msg || '网络异常请重试',
            className: 'is-theme-dark is-align-middle'
          });
          return false;
        }
        // 更新状态
        buyerCoupon.updateCoupon({
          ...coupon,
          user_coupon_state: 1
        });
        return res;
      }).catch(e => {
        setIsLoading(false);
        message.error({
          content: e?.message || '网络异常请重试',
          className: 'is-theme-dark is-align-middle'
        });
      });
      return res;
    }
    return false;
  }, [isLoading, coupon]);
  return {
    receiveCoupon,
    isLoading
  };
};
export default useReceiveCoupon;